import { useQuery } from "@tanstack/react-query";
import { getPostById } from "../../../api/apiBlog";
import i18next from "i18next";

export const useGetPostById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["post", id, i18next.language],
        queryFn: () => getPostById(id),
        enabled: !!id,
    });

    return {
        post: data?.data,
        isLoading,
        error,
        refetch,
    };
};
